
export default {
  props: {
    cancellation: {
      type: Object,
      required: true,
    },
  },
}
